// extracted by mini-css-extract-plugin
export default {"slider":"carrousel_slider__MgCxv","sliderContainer":"carrousel_sliderContainer__lSUng","img":"carrousel_img__tGOrw"};